/* ==========================================================================
   NV — Descuento de suscriptor, sin código
   --------------------------------------------------------------------------
   Cuando alguien se suscribe en el pop-up, se le aplica el descuento al
   carrito de Releasit por detrás. El cliente no escribe nada ni ve un cupón:
   pulsa "suscribirme", cierra, y el precio ya está rebajado.

   Cómo funciona
   -------------
   Releasit lleva su propio carrito de Storefront API. Añadirle un código con
   cartDiscountCodesUpdate SÍ se aplica y convive con los códigos de pack en
   lugar de reemplazarlos (el descuento está creado como combinable con
   producto y pedido).

   Resultados medidos:
     1 masajeador   179.900 → 159.900
     2 masajeadores 279.800 → 259.800
     3 masajeadores 359.700 → 339.700

   Regla de oro
   ------------
   Los precios de la página SOLO se reescriben mientras el SERVIDOR confirme
   que el descuento está aplicado. Si algo falla, o si deja de estarlo, la
   web vuelve al precio completo: nunca se anuncia menos de lo que se cobra.

   Dos cosas medidas en vivo el 2026-08-04 que condicionan todo el diseño:

     · _rsiV2.getState().cartInfo MIENTE. No solo en el total: también puede
       no traer todavía un código que el servidor ya tiene. Por eso el estado
       local se usa únicamente para detectar QUE algo ha cambiado, nunca para
       decidir si hay descuento. Eso se le pregunta al servidor.

     · Releasit reescribe la lista de códigos de su carrito durante el
       arranque y se lleva el nuestro por delante — mismo carrito, otra
       lista. De ahí la espera a que el carrito se quede quieto y el
       vigilante que lo comprueba después.
   ========================================================================== */

(function () {
  'use strict';

  var CODIGO   = 'BIENVENIDA20';
  var REBAJA   = 2000000;          /* 20.000 COP en céntimos */
  var MARCA    = 'nv_desc_activo';

  var CIEN     = 10000;            /* 100 COP en céntimos */
  var VIGENCIA = 20000;            /* una confirmación del servidor dura esto */

  var API = '/api/2026-04/graphql.json';

  var confCart = null;             /* carrito con el código confirmado */
  var confT    = 0;                /* cuándo lo confirmó el servidor */

  var reaplicando  = false;
  var comprobando  = false;
  var pendiente    = false;
  var reloj        = null;

  var MONEY = new Intl.NumberFormat('es-CO', { maximumFractionDigits: 0 });
  function money(cents) { return '$' + MONEY.format(Math.round(cents / 100)); }

  /* Lee el primer importe de un texto conservando su formato: en el widget
     de packs conviven "$179.900" y "$179.900,00" y hay que devolver cada
     uno como estaba. */
  function leerMoneda(txt) {
    var m = String(txt).match(/\$\s*\d[\d.]*(?:,\d{1,2})?/);
    if (!m) return null;
    var cuerpo = m[0].replace(/[^\d.,]/g, '');
    var dec = /,\d{1,2}$/.test(cuerpo);
    var num = parseFloat(cuerpo.replace(/\./g, '').replace(',', '.'));
    if (isNaN(num)) return null;
    return { texto: m[0], cents: Math.round(num * 100), dec: dec };
  }

  function escribirMoneda(cents, dec) {
    return '$' + new Intl.NumberFormat('es-CO', {
      minimumFractionDigits: dec ? 2 : 0,
      maximumFractionDigits: dec ? 2 : 0
    }).format(cents / 100);
  }

  function techoCien(cents) { return Math.ceil(cents / CIEN) * CIEN; }

  function activo() {
    try { return localStorage.getItem(MARCA) === '1'; } catch (e) { return false; }
  }
  function marcar() {
    try { localStorage.setItem(MARCA, '1'); } catch (e) {}
  }

  /* ---- Carrito de Releasit ----------------------------------------------- */

  function estado() {
    try { return window._rsiV2 && window._rsiV2.getState ? window._rsiV2.getState() : null; }
    catch (e) { return null; }
  }

  function token() {
    try { return window._RSI_COD_FORM_SETTINGS.general.storefrontAccessToken; }
    catch (e) { return null; }
  }

  function carritoId() {
    var st = estado();
    return st && st.cartInfo && st.cartInfo.id ? st.cartInfo.id : null;
  }

  function gql(query, variables) {
    var tok = token();
    if (!tok) return Promise.resolve(null);
    return fetch(API, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Shopify-Storefront-Access-Token': tok },
      body: JSON.stringify({ query: query, variables: variables })
    })
    .then(function (r) { return r.json(); })
    .catch(function () { return null; });
  }

  function llevaCodigo(codes) {
    return (codes || []).some(function (d) { return d.code === CODIGO && d.applicable; });
  }

  /* Los códigos que el servidor tiene ahora mismo. null si no se sabe. */
  function consultar(id) {
    return gql('query($id: ID!) { cart(id: $id) { discountCodes { code applicable } } }', { id: id })
      .then(function (r) {
        var c = r && r.data && r.data.cart;
        return c ? (c.discountCodes || []) : null;
      });
  }

  /* ¿Lleva esta página el bloque de compra de Releasit? Si lo lleva, hay que
     esperar a que pinte el selector antes de tocarle el carrito. Si no —la
     portada, por ejemplo—, no hay código de pack que se pueda romper y
     esperarlo dejaría el descuento sin aplicar para siempre. */
  function hayBloqueReleasit() {
    return !!document.querySelector('.rsi-app-block-container, #rsi-button-hook');
  }
  function hayPacks() {
    return !!document.querySelector('.rsi_embedded_quantity_wrapper .rsi-quantity-product');
  }

  /* ¿Va a haber selector de packs, o no lo habrá nunca? Releasit solo lo
     pinta con más de una oferta configurada. Con los packs desactivados el
     selector no llega jamás, y esperarlo dejaba al cliente mirando
     "aplicando tu descuento" indefinidamente. La lista viene en el HTML, así
     que se sabe desde el primer momento. */
  function habraPacks() {
    try {
      var o = window._RSI_COD_FORM_QUANTIY_OFFERS;
      return !!(o && o.length > 1);
    } catch (e) { return false; }
  }

  /* Unidades en el carrito de Releasit. null si aún no se sabe.
     Sin packs, el carrito nace VACÍO y no se llena hasta que el cliente abre
     el formulario. Sobre un carrito vacío Shopify devuelve el código como no
     aplicable, así que hasta entonces no hay nada que aplicar ni que
     prometer. */
  function unidadesCarrito() {
    var st = estado();
    var cart = st && st.cartInfo;
    if (!cart) return null;
    return typeof cart.totalQuantity === 'number' ? cart.totalQuantity : null;
  }

  /* El importe que el widget da por bueno para la opción marcada, antes de
     nuestra rebaja. Es la vara de medir: el servidor tiene que cobrar
     exactamente eso menos los 20.000. */
  function totalSeleccionado() {
    var packs = document.querySelectorAll('.rsi_embedded_quantity_wrapper .rsi-quantity-product');
    for (var i = 0; i < packs.length; i++) {
      var radio = packs[i].querySelector('input[type="radio"]');
      if (!radio || !radio.checked) continue;

      var caja = packs[i].querySelector('.rsi-quantity-price-wrapper');
      if (!caja) return null;

      var destino = null;
      Array.prototype.forEach.call(caja.children, function (h) {
        if (!h.classList.contains('rsi-quantity-old-price')) destino = h;
      });
      if (!destino) return null;

      var m = leerMoneda(textoOriginal(destino));
      return m ? m.cents : null;
    }
    return null;
  }

  /* ---- La comprobación que manda -----------------------------------------
     No basta con que el código esté puesto: el servidor tiene que estar
     cobrando exactamente lo que la página anuncia. Se comprueban las dos
     cosas de una vez.

     Devuelve 'ok' · 'sin-codigo' · 'descuadre' · null (no se sabe). ------- */

  function comprobar() {
    var id = carritoId();
    if (!id) return Promise.resolve(null);

    /* Donde hay selector de packs, la página anuncia TOTALES y hay que
       compararlos. Donde no lo hay —la portada— solo se anuncia el precio de
       una unidad, y para eso basta con que el servidor confirme el código. */
    var esperado = totalSeleccionado();
    if (esperado === null && hayPacks()) return Promise.resolve(null);

    return gql(
      'query($id: ID!) { cart(id: $id) { discountCodes { code applicable }' +
      ' cost { totalAmount { amount } } } }', { id: id }
    ).then(function (r) {
      var c = r && r.data && r.data.cart;
      if (!c) return null;

      if (!llevaCodigo(c.discountCodes)) return 'sin-codigo';

      if (esperado === null) {          /* sin packs: nada que cuadrar */
        confCart = id; confT = Date.now();
        return 'ok';
      }

      /* Se compara contra el total del carrito. Basta mientras el carrito
         solo lleve el producto: los extras se añaden dentro del formulario
         de Releasit, no aquí. Si algún día se añaden extras en la página,
         este total subirá y el descuento dejará de mostrarse — molesto,
         pero por el lado seguro. */
      var cobra = Math.round(parseFloat(c.cost.totalAmount.amount) * 100);
      if (!isFinite(cobra)) return null;

      /* Solo importa un sentido: que no se anuncie menos de lo que se cobra.
         Si el servidor cobra menos, la web se queda corta y eso no engaña. */
      if (cobra > esperado - REBAJA) return 'descuadre';

      confCart = id; confT = Date.now();
      return 'ok';
    });
  }

  function confirmado() {
    var id = carritoId();
    return !!id && id === confCart && (Date.now() - confT) < VIGENCIA;
  }

  /* ---- Sonda de precio ---------------------------------------------------
     Hay páginas donde Releasit no llega a llenar ningún carrito: la portada
     siempre, y la de producto hasta que el cliente pulsa "Pedir ahora". Ahí
     no hay nada contra lo que confirmar… pero la promesa que se hace es
     sencilla —"esta unidad te cuesta X"— y eso SÍ se puede comprobar.

     Se crea un carrito aparte con una unidad, se le aplica el código y se
     mira lo que responde el servidor. No se paga con él, no se toca el de
     Releasit y no se enseña: es una consulta de precio y se descarta. Con
     eso la web puede rebajar el precio sabiendo que es verdad.

     El resultado se guarda un rato en la sesión para no crear un carrito de
     sonda en cada visita a cada página. ---------------------------------- */

  /* Un "sí" del servidor aguanta un rato: el precio no cambia cada minuto.
     Un "no" caduca enseguida — puede ser un fallo pasajero de red o que la
     página aún no expusiera la variante, y guardarlo 15 minutos deja al
     suscriptor sin su precio durante todo ese rato. */
  var SONDA_OK_MS = 900000;         /* 15 min */
  var SONDA_NO_MS = 60000;          /*  1 min */
  var sondaOk = false, sondaEnCurso = false, sondaProxima = 0;

  function sondaGuardada() {
    try {
      var v = sessionStorage.getItem('nv_sonda');
      if (!v) return null;
      var p = v.split('|');
      var ok = p[0] === '1';
      if ((Date.now() - parseInt(p[1], 10)) > (ok ? SONDA_OK_MS : SONDA_NO_MS)) return null;
      return ok;
    } catch (e) { return null; }
  }

  function guardarSonda(ok) {
    try { sessionStorage.setItem('nv_sonda', (ok ? '1' : '0') + '|' + Date.now()); } catch (e) {}
  }

  function sonda() {
    var el = document.querySelector('[data-nv-variante][data-nv-unidad]');
    if (!el) return Promise.resolve(false);

    var unidad = parseInt(el.getAttribute('data-nv-unidad'), 10);
    var vid = el.getAttribute('data-nv-variante');
    if (!isFinite(unidad) || unidad <= REBAJA || !vid) return Promise.resolve(false);

    return gql(
      'mutation($lines: [CartLineInput!]!, $codes: [String!]!) {' +
      ' cartCreate(input: { lines: $lines, discountCodes: $codes }) {' +
      '   cart { discountCodes { code applicable } cost { totalAmount { amount } } }' +
      '   userErrors { message } } }',
      { lines: [{ merchandiseId: 'gid://shopify/ProductVariant/' + vid, quantity: 1 }], codes: [CODIGO] }
    ).then(function (r) {
      var c = r && r.data && r.data.cartCreate && r.data.cartCreate.cart;
      if (!c || !llevaCodigo(c.discountCodes)) return false;
      var cobra = Math.round(parseFloat(c.cost.totalAmount.amount) * 100);
      /* Solo vale si el servidor cobra como mucho lo que vamos a anunciar. */
      return isFinite(cobra) && cobra <= (unidad - REBAJA);
    });
  }

  /* ---- Poner al día el formulario de Releasit ----------------------------
     El formulario pinta su total desde su propio estado, y ese estado se
     queda con el carrito de ANTES del descuento: enseñaba 279.800 y
     "COMPLETA TU COMPRA - $279.800" cuando el servidor ya cobraba 259.800.
     Cobrar de menos y mostrar de más es el lado seguro, pero confunde justo
     a quien acaba de suscribirse.

     Releasit vuelve a pedir el carrito al servidor cuando le cambia
     triggerCartUpdate. Es interno suyo, así que va envuelto en try y con
     tope: si algún día deja de existir, esto no hace nada y todo lo demás
     sigue funcionando igual. Verificado en vivo el 2026-08-04: el total y el
     botón pasan a 259.800 sin cerrar el formulario. -------------------- */

  var TOPE_EMPUJONES = 5;
  var empujones = 0;

  function releasitDesfasado() {
    var st = estado();
    var cart = st && st.cartInfo;
    return !!cart && !llevaCodigo(cart.discountCodes);
  }

  function empujarReleasit() {
    if (empujones >= TOPE_EMPUJONES) return;
    try {
      if (!window._rsiV2 || !window._rsiV2.setState || !window._rsiV2.getState) return;
      var n = window._rsiV2.getState().triggerCartUpdate;
      empujones++;
      window._rsiV2.setState({ triggerCartUpdate: (typeof n === 'number' ? n : 0) + 1 });
    } catch (e) {}
  }

  /* ---- Animación de los números ------------------------------------------
     El precio no debe dar un salto seco de 159.900 a 139.900: se ve como un
     error. Baja contando, y el porcentaje sube contando.

     La dirección no es casual y es lo que la hace segura: el precio baja
     hacia el valor final, así que todos los valores intermedios son MAYORES
     que lo que se va a cobrar; y el porcentaje sube, así que los intermedios
     son MENORES que el descuento real. Ni un solo fotograma promete de más.

     Con `prefers-reduced-motion` se escribe el valor final y ya. ---------- */

  var ANIM_MS = 850;

  function animable() {
    try { return !window.matchMedia('(prefers-reduced-motion: reduce)').matches; }
    catch (e) { return true; }
  }

  function animarValor(el, desde, hasta, pinta) {
    if (el._nvAnim) { cancelAnimationFrame(el._nvAnim); el._nvAnim = null; }

    if (desde === hasta || !animable()) { el.textContent = pinta(hasta); return; }

    var t0 = null;
    el.classList.add('nv-num-anim');

    function rematar() {
      if (el._nvAnim) { cancelAnimationFrame(el._nvAnim); el._nvAnim = null; }
      if (el._nvFin) { clearTimeout(el._nvFin); el._nvFin = null; }
      el.textContent = pinta(hasta);               /* el final, exacto, nunca interpolado */
      el.classList.remove('nv-num-anim');
    }

    function paso(t) {
      if (t0 === null) t0 = t;
      var p = Math.min(1, (t - t0) / ANIM_MS);
      var e = 1 - Math.pow(1 - p, 3);              /* ease-out: rápido al principio */

      if (p < 1) {
        el.textContent = pinta(Math.round(desde + (hasta - desde) * e));
        el._nvAnim = requestAnimationFrame(paso);
      } else {
        rematar();
        /* El pulso necesita inline-block para que el transform surta efecto,
           y eso RESUCITA cualquier elemento oculto con display:none — pasó
           con la chapa del descuento sobre la foto, que está oculta a
           propósito y reaparecía un segundo al terminar la cuenta.
           Solo se le pone el pulso a lo que ya se está viendo. */
        var visible = false;
        try { visible = getComputedStyle(el).display !== 'none'; } catch (e) {}
        if (!visible) return;

        el.classList.add('nv-num-listo');
        window.setTimeout(function () { el.classList.remove('nv-num-listo'); }, 700);
      }
    }

    /* Red de seguridad: en una pestaña de fondo requestAnimationFrame no
       corre, y sin esto el número se quedaría congelado en el valor viejo
       hasta que el cliente volviera a la pestaña. Los temporizadores sí
       siguen, así que aquí se escribe el final y se acabó. */
    if (el._nvFin) clearTimeout(el._nvFin);
    el._nvFin = window.setTimeout(rematar, ANIM_MS + 500);

    el._nvAnim = requestAnimationFrame(paso);
  }

  function pararAnimacion(el) {
    if (el._nvAnim) { cancelAnimationFrame(el._nvAnim); el._nvAnim = null; }
    if (el._nvFin) { clearTimeout(el._nvFin); el._nvFin = null; }
    el.classList.remove('nv-num-anim', 'nv-num-listo');
  }

  /* ---- Aplicar el descuento ----------------------------------------------
     La lista de códigos se lee del SERVIDOR, nunca del estado local. Si se
     enviara una lista incompleta se borraría de paso el código de pack de
     Releasit y el cliente acabaría pagando más de lo que se le anuncia. ---- */

  function aplicar() {
    var id = carritoId();
    if (!id || !token()) return Promise.resolve(false);

    return consultar(id).then(function (codes) {
      if (codes === null) return false;
      if (llevaCodigo(codes)) return true;

      var lista = codes.map(function (d) { return d.code; });
      lista.push(CODIGO);

      return gql(
        'mutation($cartId: ID!, $codes: [String!]!) {' +
        ' cartDiscountCodesUpdate(cartId: $cartId, discountCodes: $codes) {' +
        '   cart { discountCodes { code applicable } }' +
        '   userErrors { message } } }',
        { cartId: id, codes: lista }
      ).then(function (r) {
        var c = r && r.data && r.data.cartDiscountCodesUpdate && r.data.cartDiscountCodesUpdate.cart;
        return !!c && llevaCodigo(c.discountCodes);
      });
    });
  }

  /* ---- Reescribir los precios visibles ----------------------------------
     Solo el precio actual, nunca el tachado: ese tiene que seguir siendo el
     de referencia. Cada elemento guarda su texto original para poder
     deshacerlo si el descuento se cae. ------------------------------------ */

  function reescribir() {
    document.documentElement.classList.add('nv-desc-activo');
    document.documentElement.classList.remove('nv-desc-atascado');
    document.documentElement.classList.remove('nv-desc-pendiente');

    /* Precio del hero de producto: lleva el importe en céntimos en data-unit,
       así que se recalcula en vez de manipular el texto. */
    document.querySelectorAll('.nv-now[data-nv-price][data-unit]').forEach(function (el) {
      if (el.hasAttribute('data-nv-desc-unit')) return;
      var unit = parseInt(el.getAttribute('data-unit'), 10);
      if (isNaN(unit) || unit <= REBAJA) return;
      el.setAttribute('data-nv-desc-unit', String(unit));
      el.setAttribute('data-unit', String(unit - REBAJA));  /* el stepper multiplica sobre esto */
      animarValor(el, unit, unit - REBAJA, money);
    });

    /* Los demás precios "ahora" de la web: el de la portada, que va escrito a
       mano en el editor, y el segundo de la página de producto, que no lleva
       data-unit. Se rebajan por texto, que es reversible. El tachado
       (.nv-old) no se toca nunca: es la referencia. */
    document.querySelectorAll('.nv-now:not([data-unit]), .nv-show__now, [data-nv-price-now]').forEach(function (el) {
      rebajar(el, function (cents) { return cents - REBAJA; });
    });

    ajustarEtiquetas();
    vigilarPacks();
    aviso();
  }

  /* ---- La etiqueta de porcentaje -----------------------------------------
     El precio baja pero el tachado no, así que el porcentaje de la etiqueta
     se queda corto: seguía diciendo -53% cuando el descuento real ya era del
     58%. Se recalcula desde lo que hay en pantalla.

     Se redondea hacia ABAJO. Un porcentaje redondeado hacia arriba promete
     más descuento del que hay, y eso es la misma mentira que anunciar un
     precio menor del que se cobra. ---------------------------------------- */

  function ajustarEtiquetas() {
    var ahora = null, antes = null;

    var cajas = document.querySelectorAll('.nv-price');
    for (var i = 0; i < cajas.length; i++) {
      var n = cajas[i].querySelector('.nv-now');
      var o = cajas[i].querySelector('.nv-old');
      if (!n || !o) continue;

      var mn = leerMoneda(n.textContent);            /* ya rebajado */
      var mo = leerMoneda(textoOriginal(o));         /* el tachado nunca se toca */
      if (!mn || !mo || mo.cents <= mn.cents) continue;

      ahora = mn.cents; antes = mo.cents;
      break;
    }
    if (ahora === null) return;

    var pct = Math.floor((antes - ahora) * 100 / antes);
    if (!isFinite(pct) || pct <= 0 || pct >= 100) return;

    document.querySelectorAll('.nv-off, .nv-badge-off').forEach(function (el) {
      var original = textoOriginal(el);
      var signo = /^\s*-/.test(original) ? '-' : '';
      var texto = signo + pct + '%';

      el.setAttribute('data-nv-desc-orig', original);
      el.setAttribute('data-nv-desc-out', texto);

      if (el.textContent !== texto) {
        var previo = parseInt(String(original).replace(/[^\d]/g, ''), 10);
        animarValor(el, isFinite(previo) ? previo : pct, pct, function (n) {
          return signo + n + '%';
        });
      }
    });
  }

  /* Deja la web como si nunca se hubiera aplicado nada. */

  function restaurar() {
    document.querySelectorAll('[data-nv-desc-orig]').forEach(function (el) {
      /* Si estaba contando, se corta: al volver atrás manda el original. */
      var contando = !!el._nvAnim;
      pararAnimacion(el);
      if (contando || el.textContent === el.getAttribute('data-nv-desc-out')) {
        el.textContent = el.getAttribute('data-nv-desc-orig');
      }
      el.removeAttribute('data-nv-desc-orig');
      el.removeAttribute('data-nv-desc-out');
    });

    document.querySelectorAll('.nv-now[data-nv-desc-unit]').forEach(function (el) {
      var unit = el.getAttribute('data-nv-desc-unit');
      pararAnimacion(el);
      el.setAttribute('data-unit', unit);
      el.textContent = money(parseInt(unit, 10));
      el.removeAttribute('data-nv-desc-unit');
    });

    var a = document.querySelector('[data-nv-desc-aviso]');
    if (a && a.parentNode) a.parentNode.removeChild(a);
    document.documentElement.classList.remove('nv-desc-activo');
  }

  /* ---- Selector de packs de Releasit ------------------------------------
     Cada opción se pinta así (verificado en el DOM en vivo):

       .rsi-quantity-title          "1 masajeador · $179.900"
                                    "2 masajeadores · $139.900 c/u · Más elegido"
       .rsi-quantity-price-wrapper  [.rsi-quantity-old-price $359.800,00] $279.800,00
       .rsi-quantity-plaque         "Ahorra $80.000 extra"

     Tres decisiones, ninguna de ellas cosmética:

     1. El importe del título es POR UNIDAD en los packs de 2 y 3 ("c/u").
        Restarle los 20.000 anunciaría 99.900 c/u = 299.700 cuando se cobran
        339.700. Se recalcula desde el total ya rebajado y se redondea hacia
        ARRIBA, para no anunciar nunca menos de lo que se cobra.
     2. El tachado (.rsi-quantity-old-price) no se toca: es la referencia.
     3. La chapa "Ahorra $80.000 extra" tampoco. Es el ahorro del pack frente
        al precio suelto; sumarle los 20.000 sería inflar una promesa de
        ahorro. Quedarse corto no engaña a nadie.

     React no repinta estos textos al cambiar de pack, así que la reescritura
     aguanta. El observador está para cuando el widget se monta tarde. ----- */

  function textoOriginal(el) {
    var g = el.getAttribute('data-nv-desc-orig');
    if (g === null) return el.textContent;
    /* Mientras cuenta, lo que se ve es un valor de paso: no vale como
       original ni como el nuestro. Manda lo guardado. */
    if (el._nvAnim) return g;
    /* Si lo que hay escrito no es lo que dejamos nosotros, el widget lo ha
       repintado: se parte del texto actual. Así ni se resta dos veces ni se
       queda un precio sin rebajar. */
    return el.textContent === el.getAttribute('data-nv-desc-out') ? g : el.textContent;
  }

  function rebajar(el, calcular) {
    var original = textoOriginal(el);
    var m = leerMoneda(original);
    if (!m || m.cents <= REBAJA) return null;

    var nuevo = calcular(m.cents);
    if (!isFinite(nuevo) || nuevo <= 0 || nuevo > m.cents) return null;

    var texto = original.replace(m.texto, escribirMoneda(nuevo, m.dec));
    /* Se anotan antes de animar: el destino ya está decidido, y así el resto
       del código sabe cuál es aunque los números aún estén contando. */
    el.setAttribute('data-nv-desc-orig', original);
    el.setAttribute('data-nv-desc-out', texto);

    if (el.textContent !== texto) {
      animarValor(el, m.cents, nuevo, function (c) {
        return original.replace(m.texto, escribirMoneda(c, m.dec));
      });
    }
    return { original: m.cents, nuevo: nuevo, texto: texto };
  }

  function rebajarPacks() {
    if (!confirmado()) return;      /* nunca se rebaja lo que no está confirmado */

    document.querySelectorAll('.rsi_embedded_quantity_wrapper .rsi-quantity-product')
      .forEach(function (pack) {
        var caja = pack.querySelector('.rsi-quantity-price-wrapper');
        if (!caja) return;

        /* El precio vigente es el último hijo que no sea el tachado. */
        var destino = null;
        Array.prototype.forEach.call(caja.children, function (hijo) {
          if (!hijo.classList.contains('rsi-quantity-old-price')) destino = hijo;
        });
        if (!destino) return;

        var total = rebajar(destino, function (cents) { return cents - REBAJA; });
        if (!total) return;

        var titulo = pack.querySelector('.rsi-quantity-title');
        if (!titulo) return;

        var previo = leerMoneda(textoOriginal(titulo));
        if (!previo) return;

        /* ¿El título repite el total o da el precio por unidad? Se deduce
           dividiendo, sin depender de que ponga "c/u". */
        var uds = Math.round(total.original / previo.cents);
        if (uds < 1 || Math.abs(uds * previo.cents - total.original) > uds * CIEN) return;

        var altPrevio = titulo.textContent;
        var hecho = rebajar(titulo, function () {
          return techoCien(Math.ceil((total.original - REBAJA) / uds));
        });

        /* Releasit copia el título en el alt de la miniatura. */
        var img = pack.querySelector('.rsi-quantity-image');
        if (hecho && img && img.getAttribute('alt') === altPrevio) {
          img.setAttribute('alt', hecho.texto);
        }
      });
  }

  function programarPacks() {
    if (pendiente) return;
    pendiente = true;
    window.requestAnimationFrame(function () { pendiente = false; rebajarPacks(); });
  }

  var obsPacks = null, obsEspera = null;

  function vigilarPacks() {
    var w = document.querySelector('.rsi_embedded_quantity_wrapper');

    if (!w) {
      /* El widget tarda unos segundos en montarse: se espera a que aparezca
         y se deja de mirar el documento en cuanto está. */
      if (!obsEspera) {
        obsEspera = new MutationObserver(vigilarPacks);
        obsEspera.observe(document.body, { childList: true, subtree: true });
        window.setTimeout(function () {
          if (obsEspera) { obsEspera.disconnect(); obsEspera = null; }
        }, 30000);
      }
      return;
    }

    if (obsEspera) { obsEspera.disconnect(); obsEspera = null; }
    if (!obsPacks) {
      obsPacks = new MutationObserver(programarPacks);
      obsPacks.observe(w, { childList: true, subtree: true, characterData: true });
    }
    rebajarPacks();
  }

  /* ---- Aviso permanente -------------------------------------------------
     El cliente tiene que saber por qué ve otro precio, y poder confiar en
     que sigue ahí cuando llegue al formulario. ---------------------------- */

  var avisoMostrado = false;

  function aviso() {
    if (avisoMostrado || document.querySelector('[data-nv-desc-aviso]')) return;
    avisoMostrado = true;

    var b = document.createElement('div');
    b.setAttribute('data-nv-desc-aviso', '');
    b.className = 'nv-desc-aviso';
    b.setAttribute('role', 'status');
    b.innerHTML = '<strong>Descuento activado</strong> · Tienes ' + money(REBAJA) +
                  ' menos en tu pedido. Se aplica solo al finalizar.';
    document.body.appendChild(b);

    /* Saluda y se va: clavado abajo del todo estorba, sobre todo en el móvil.
       El estado permanente ya lo cuenta el bloque de los packs. */
    window.setTimeout(function () {
      b.classList.add('nv-desc-aviso--fuera');
      window.setTimeout(function () {
        if (b.parentNode) b.parentNode.removeChild(b);
      }, 600);
    }, 5000);
  }

  /* ---- Arranque ---------------------------------------------------------
     Releasit crea su carrito unos segundos después de cargar la página y
     durante ese rato le reescribe los códigos varias veces. Aplicar antes
     de tiempo no sirve: lo borra. Se espera a que el carrito deje de
     moverse — misma firma dos vueltas seguidas — y solo entonces se
     aplica. --------------------------------------------------------------- */

  function firma() {
    var st = estado();
    var cart = st && st.cartInfo;
    if (!cart || !cart.id) return null;
    /* Las unidades entran en la firma: sin packs, el carrito pasa de vacío a
       lleno al abrir el formulario y ese es el momento de aplicar. */
    return cart.id + '|' + (cart.totalQuantity || 0) + '|' + (cart.discountCodes || [])
      .map(function (d) { return d.code; }).sort().join(',');
  }

  var firmaPrevia = null, quieto = 0, firmaVista = null;

  function intentar(restantes) {
    if (restantes <= 0) { reaplicando = false; return; }

    var f = firma();
    if (f === null) {
      window.setTimeout(function () { intentar(restantes - 1); }, 350);
      return;
    }

    /* No se toca el carrito hasta que Releasit ha pintado el selector. Si se
       le añade un código antes, el código de pack de Releasit ya no llega a
       aplicarse y el cliente pierde el descuento por volumen: medido, el
       pack de 2 acabó costando 303.820 en vez de 279.800.
       En páginas sin bloque de Releasit no hay nada que esperar. */
    /* …pero no para siempre. Si Releasit no llega a pintar el selector —pasa,
       y cuando pasa el cliente se queda mirando "aplicando tu descuento" sin
       fin—, a los ESPERA_WIDGET se sigue adelante: sin selector no hay código
       de pack que estropear, y la comprobación contra el servidor sigue
       protegiendo de anunciar de menos. */
    if (hayBloqueReleasit() && habraPacks() && !hayPacks() && !venceEspera()) {
      window.setTimeout(function () { intentar(restantes - 1); }, 350);
      return;
    }

    /* Carrito vacío: no es un fallo, es que el pedido aún no ha empezado. Se
       deja para cuando haya algo dentro, sin gastar intentos ni llamadas. */
    if (unidadesCarrito() === 0) { reaplicando = false; return; }

    if (f !== firmaPrevia) { firmaPrevia = f; quieto = 0; }
    else { quieto++; }

    if (quieto < 2) {
      window.setTimeout(function () { intentar(restantes - 1); }, 350);
      return;
    }

    /* Aplicar no basta para creérselo: se le pregunta al servidor qué está
       cobrando de verdad, y solo entonces se rebaja la pantalla. */
    aplicar().then(function (ok) {
      reaplicando = false;
      firmaPrevia = firma();
      if (!ok) { window.setTimeout(function () { intentar(restantes - 1); }, 600); return; }
      return comprobar().then(function (r) {
        if (r === 'ok') reescribir();
        else restaurar();
      });
    }, function () { reaplicando = false; });
  }

  /* ---- Vigilante --------------------------------------------------------
     Cada vuelta mira, en local y sin coste, si el carrito se ha movido. El
     estado local vale para eso; para saber si el código sigue puesto, no.
     Eso se le pregunta al servidor, y hasta que conteste no se anuncia
     ninguna rebaja. El tope de reintentos evita pelearse con el servidor:
     agotado, el cliente ve el precio completo, que es el lado seguro. ----- */

  var MAX_REAPLICACIONES = 12;
  var reaplicaciones = 0;

  /* ---- Que nunca se quede "aplicando" para siempre -----------------------
     Un cliente no espera minutos mirando un mensaje de carga. Si en
     ESPERA_WIDGET no hay selector, se aplica igual. Y si a los PACIENCIA
     seguimos sin poder confirmar nada, se deja de prometer: la clase
     nv-desc-atascado cambia el texto por uno que dice la verdad y le da algo
     que hacer. -------------------------------------------------------- */

  var ESPERA_WIDGET = 12000;
  var PACIENCIA     = 25000;
  var arranqueT     = 0;

  function venceEspera() {
    return arranqueT > 0 && (Date.now() - arranqueT) > ESPERA_WIDGET;
  }

  function revisarPaciencia() {
    if (!arranqueT || confirmado()) return;
    if (unidadesCarrito() === 0) return;   /* esperar a que haya pedido no es atascarse */
    if ((Date.now() - arranqueT) > PACIENCIA) {
      document.documentElement.classList.add('nv-desc-atascado');
    }
  }

  function paso() {
    if (!activo()) return;

    var f = firma();
    if (f === null) return;

    var cambio = (f !== firmaVista);
    firmaVista = f;

    /* Carrito nuevo, oportunidad nueva: se devuelven los reintentos. Si no,
       una racha mala deja al cliente sin descuento el resto de la visita. */
    if (cambio && carritoId() !== confCart) reaplicaciones = 0;

    /* Carrito vacío: el pedido aún no ha empezado, así que no hay nada que
       confirmar contra él. Pero el precio de una unidad sí se puede
       comprobar con la sonda, y si el servidor lo confirma se rebaja. Si no
       se puede, se dice la verdad —"se descuenta al hacer el pedido"— en vez
       de dejar un "cargando" eterno. */
    if (unidadesCarrito() === 0) {
      document.documentElement.classList.remove('nv-desc-atascado');

      if (sondaOk) { reescribir(); return; }

      var previo = sondaGuardada();
      if (previo === true) { sondaOk = true; reescribir(); return; }

      /* Si no hay respuesta guardada y no toca esperar, se vuelve a preguntar. */
      if (previo === null && !sondaEnCurso && Date.now() > sondaProxima) {
        sondaEnCurso = true;
        sondaProxima = Date.now() + SONDA_NO_MS;
        sonda().then(function (ok) {
          sondaEnCurso = false;
          guardarSonda(ok);
          if (ok) { sondaOk = true; reescribir(); }
        }, function () { sondaEnCurso = false; });
      }

      document.documentElement.classList.add('nv-desc-pendiente');
      restaurar();
      return;
    }
    document.documentElement.classList.remove('nv-desc-pendiente');

    if (confirmado() && !cambio) {
      rebajarPacks();
      /* Si el estado de Releasit se ha quedado atrás, se le pide que
         recargue el carrito: así el formulario enseña el total de verdad. */
      if (releasitDesfasado()) empujarReleasit();
      return;
    }

    /* Carrito distinto del confirmado: ese seguro que no lleva el código. */
    if (carritoId() !== confCart) restaurar();

    revisarPaciencia();

    if (comprobando) return;
    comprobando = true;

    var fin = function (r) {
      comprobando = false;

      if (r === 'ok') { reescribir(); return; }

      /* Cualquier otra cosa: fuera la rebaja de la pantalla. */
      restaurar();

      /* Solo se reintenta si falta el código. Si el descuadre es otro —el
         código está pero el servidor cobra otra cosa— insistir no arregla
         nada y podría empeorarlo: se deja el precio completo. */
      if (r === 'sin-codigo' && !reaplicando && reaplicaciones < MAX_REAPLICACIONES) {
        reaplicando = true;
        reaplicaciones++;
        intentar(10);
      }
    };

    /* El catch no es decorativo: si una promesa se rompe sin recogerla, el
       testigo se queda puesto y el vigilante no vuelve a comprobar nada en
       toda la sesión. Ya pasó. */
    comprobar().then(fin, function () { comprobando = false; });
  }

  /* Y una red por debajo: una excepción aquí no puede matar el intervalo. */
  function vigilar() {
    try { paso(); }
    catch (e) { comprobando = false; }
  }

  /* ---- Ritmo de vigilancia ----------------------------------------------
     Normalmente basta con mirar cada segundo y medio: es estado local, no
     cuesta nada, pero tampoco urge. Cuando el cliente pulsa "Pedir ahora"
     sabemos que el carrito está a punto de llenarse, y ahí sí urge: es el
     momento exacto en que puede aplicarse el descuento y el único en que el
     cliente está mirando. -------------------------------------------------- */

  var prisaHasta = 0;

  function ritmo() { return Date.now() < prisaHasta ? 300 : 1500; }

  function vigilancia() {
    if (reloj) return;
    reloj = true;
    (function ciclo() {
      vigilar();
      window.setTimeout(ciclo, ritmo());
    })();
  }

  document.addEventListener('click', function (e) {
    if (!activo()) return;
    if (!e.target || !e.target.closest) return;
    if (!e.target.closest('#rsi-button-hook button, .rsi-custom-button, .rsi-app-block-container button')) return;
    prisaHasta = Date.now() + 15000;
    if (!reaplicando) { reaplicando = true; intentar(20); }
  }, true);

  function arrancar() {
    if (!activo()) return;
    arranqueT = Date.now();
    intentar(30);
    vigilancia();
  }

  /* Para depurar desde la consola sin tener que adivinar qué está pasando:
     nvDescuentoEstado() dice en qué punto se ha quedado. */
  window.nvDescuentoEstado = function () {
    return {
      activo: activo(),
      carrito: carritoId(),
      confirmadoEn: confCart,
      confirmadoHace: confT ? (Date.now() - confT) : null,
      vigente: confirmado(),
      comprobando: comprobando,
      reaplicando: reaplicando,
      reaplicaciones: reaplicaciones,
      intervaloVivo: !!reloj,
      widget: !!document.querySelector('.rsi_embedded_quantity_wrapper .rsi-quantity-product'),
      totalSeleccionado: totalSeleccionado(),
      firma: firma()
    };
  };

  /* Se expone para que el pop-up lo dispare justo tras suscribirse. */
  window.nvActivarDescuento = function () {
    marcar();
    arranqueT = Date.now();
    document.documentElement.classList.remove('nv-desc-atascado');
    reaplicaciones = 0;
    firmaPrevia = null;
    quieto = 0;
    intentar(30);
    vigilancia();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', arrancar, { once: true });
  } else {
    arrancar();
  }
})();
